import { render, staticRenderFns } from "./PublicAndPrivateAppsIcon.vue?vue&type=template&id=c0f33bcc"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports